var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded)?_c('crud-form',{attrs:{"schema":_vm.schema,"path":'tag-item-price/recalculate',"form-title":_vm.$t('tagItemPriceRecalculation'),"redirect-route":'TagItemRecalculationList',"model":{
      value: 0,
      products: [],
      tagItem: _vm.tagItem
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }